var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import firebase from 'firebase';
import * as _ from 'lodash';
import gql from 'graphql-tag';
import { db, config } from '@/services/firebase';
import { strToFloat } from '@/services/sharedForm';
import { CARRIERS, COMPANIES, EXTERNALS, LOCATIONS, PRODUCTS, SILOS } from '@/queries/admin';
var Admin = /** @class */ (function (_super) {
    __extends(Admin, _super);
    function Admin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.altCompanies = [];
        _this.altCarriers = [];
        _this.altRoles = [];
        _this.altLocations = [];
        _this.altProducts = [];
        _this.silos = [];
        _this.externals = [];
        _this.showEditUser = false;
        _this.editUserEmailClass = '';
        _this.editUserEmailWarning = '';
        _this.editUserEmail = '';
        _this.editUserCompany = '';
        _this.editUserRole = '';
        _this.editUserCurrent = {};
        _this.editUserLoading = false;
        _this.editUserResetEmailLoading = false;
        _this.showEditSilo = false;
        _this.editSiloName = '';
        _this.editSiloCompany = '';
        _this.editSiloLocation = '';
        _this.editSiloCapacity = null;
        _this.editSiloCurrentWeight = null;
        _this.editSiloFeetDown = null;
        _this.editSiloHeight = null;
        _this.editSiloCurrent = {};
        _this.editSiloLoading = false;
        _this.editSiloProduct = '';
        _this.showEditExternal = false;
        _this.editExternalCompany = '';
        _this.editExternalLocation = '';
        _this.editExternalCurrentWeight = null;
        _this.editExternalLoading = false;
        _this.editExternalProduct = '';
        _this.editExternalCurrent = {};
        _this.isCSVLoading = false;
        return _this;
    }
    Admin.prototype.metaInfo = function () {
        return {
            title: 'Admin Console'
        };
    };
    Admin.prototype.mounted = function () {
        var _this = this;
        if (!this.secondaryApp) {
            this.secondaryApp = firebase.initializeApp(config, 'Secondary');
        }
        this.$watch('roles', function (val) {
            _this.altRoles = _this.roles.slice();
        }, { immediate: true, deep: true });
    };
    Admin.prototype.destroyed = function () {
        if (this.secondaryApp) {
            this.secondaryApp.delete();
        }
    };
    Object.defineProperty(Admin.prototype, "showEditUserSection", {
        get: function () {
            return this.showEditUser || !this.users.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Admin.prototype, "showEditSiloSection", {
        get: function () {
            return this.showEditSilo || !this.silos.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Admin.prototype, "showEditExternalSection", {
        get: function () {
            return this.showEditExternal || !this.externals.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Admin.prototype, "currentUser", {
        get: function () {
            return this.editUserCurrent && this.editUserCurrent.email;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Admin.prototype, "currentSilo", {
        get: function () {
            return this.editSiloCurrent && this.editSiloCurrent.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Admin.prototype, "currentExternal", {
        get: function () {
            return this.editExternalCurrent && this.editExternalCurrent.location;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Admin.prototype, "canDeleteUser", {
        get: function () {
            return this.editUserCurrent && this.editUserCurrent.email && firebase.auth().currentUser.email !== this.editUserCurrent.email;
        },
        enumerable: true,
        configurable: true
    });
    Admin.prototype.carrierAdded = function (carrier) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["mutation ($carriers: [carriers_insert_input!]!) {\n          insert_carriers(objects: $carriers) {\n            affected_rows\n          }\n        }"], ["mutation ($carriers: [carriers_insert_input!]!) {\n          insert_carriers(objects: $carriers) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    carriers: [{
                                            name: carrier
                                        }]
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [4 /*yield*/, this.$apollo.queries.carriers.refetch()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.carrierRemoved = function (carrier) {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["mutation ($carrier: String!) {\n          delete_carriers(where: {name: {_eq: $carrier}}) {\n            affected_rows\n          }\n        }"], ["mutation ($carrier: String!) {\n          delete_carriers(where: {name: {_eq: $carrier}}) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    carrier: carrier.name
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        e_2 = _a.sent();
                        return [4 /*yield*/, this.$apollo.queries.carriers.refetch()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.carrierRemovedDialog = function (carrier) {
        var _this = this;
        this.$dialog.confirm({
            title: 'Deleting Carrier',
            message: 'Are you sure you want to <b>delete</b> this carrier? This action cannot be undone.',
            confirmText: 'Delete',
            type: 'is-danger',
            hasIcon: true,
            onConfirm: function () { return _this.carrierRemoved(carrier); },
            onCancel: function () { return _this.$apollo.queries.carriers.refetch(); }
        });
    };
    Admin.prototype.companyAdded = function (company) {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["mutation ($companies: [companies_insert_input!]!) {\n          insert_companies(objects: $companies) {\n            affected_rows\n          }\n        }"], ["mutation ($companies: [companies_insert_input!]!) {\n          insert_companies(objects: $companies) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    companies: [{
                                            name: company
                                        }]
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [4 /*yield*/, this.$apollo.queries.companies.refetch()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.companyRemoved = function (company) {
        return __awaiter(this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["mutation ($company: String!) {\n          delete_companies(where: {name: {_eq: $company}}) {\n            affected_rows\n          }\n        }"], ["mutation ($company: String!) {\n          delete_companies(where: {name: {_eq: $company}}) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    company: company.name
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        e_4 = _a.sent();
                        return [4 /*yield*/, this.$apollo.queries.companies.refetch()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.companyRemovedDialog = function (company) {
        var _this = this;
        this.$dialog.confirm({
            title: 'Deleting Company',
            message: 'Are you sure you want to <b>delete</b> this company? This action cannot be undone.',
            confirmText: 'Delete',
            type: 'is-danger',
            hasIcon: true,
            onConfirm: function () { return _this.companyRemoved(company); },
            onCancel: function () { return _this.$apollo.queries.companies.refetch(); }
        });
    };
    Admin.prototype.roleAdded = function (role) {
        this.$firebaseRefs.roles.push({
            name: role
        });
    };
    Admin.prototype.roleRemoved = function (role) {
        this.$firebaseRefs.roles.child(role['.key']).remove();
    };
    Admin.prototype.roleRemovedDialog = function (role) {
        var _this = this;
        this.$dialog.confirm({
            title: 'Deleting Role',
            message: 'Are you sure you want to <b>delete</b> this role? This action cannot be undone.',
            confirmText: 'Delete',
            type: 'is-danger',
            hasIcon: true,
            onConfirm: function () { return _this.roleRemoved(role); },
            onCancel: function () { return _this.altRoles = _this.roles.slice(); }
        });
    };
    Admin.prototype.locationAdded = function (location) {
        return __awaiter(this, void 0, void 0, function () {
            var e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["mutation ($locations: [locations_insert_input!]!) {\n          insert_locations(objects: $locations) {\n            affected_rows\n          }\n        }"], ["mutation ($locations: [locations_insert_input!]!) {\n          insert_locations(objects: $locations) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    locations: [{
                                            name: location
                                        }]
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_5 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [4 /*yield*/, this.$apollo.queries.locations.refetch()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.locationRemoved = function (location) {
        return __awaiter(this, void 0, void 0, function () {
            var e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["mutation ($location: String!) {\n          delete_locations(where: {name: {_eq: $location}}) {\n            affected_rows\n          }\n        }"], ["mutation ($location: String!) {\n          delete_locations(where: {name: {_eq: $location}}) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    location: location.name
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        e_6 = _a.sent();
                        return [4 /*yield*/, this.$apollo.queries.locations.refetch()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.locationRemovedDialog = function (location) {
        var _this = this;
        this.$dialog.confirm({
            title: 'Deleting Location',
            message: 'Are you sure you want to <b>delete</b> this location? This action cannot be undone.',
            confirmText: 'Delete',
            type: 'is-danger',
            hasIcon: true,
            onConfirm: function () { return _this.locationRemoved(location); },
            onCancel: function () { return _this.$apollo.queries.locations.refetch(); }
        });
    };
    Admin.prototype.sandTypeAdded = function (product) {
        return __awaiter(this, void 0, void 0, function () {
            var e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["mutation ($products: [products_insert_input!]!) {\n          insert_products(objects: $products) {\n            affected_rows\n          }\n        }"], ["mutation ($products: [products_insert_input!]!) {\n          insert_products(objects: $products) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    products: [{
                                            name: product
                                        }]
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_7 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [4 /*yield*/, this.$apollo.queries.products.refetch()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.sandTypeRemoved = function (product) {
        return __awaiter(this, void 0, void 0, function () {
            var e_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["mutation ($product: String!) {\n          delete_products(where: {name: {_eq: $product}}) {\n            affected_rows\n          }\n        }"], ["mutation ($product: String!) {\n          delete_products(where: {name: {_eq: $product}}) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    product: product.name
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        e_8 = _a.sent();
                        return [4 /*yield*/, this.$apollo.queries.products.refetch()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.sandTypeRemovedDialog = function (product) {
        var _this = this;
        this.$dialog.confirm({
            title: 'Deleting Sand Type',
            message: 'Are you sure you want to <b>delete</b> this sand type? This action cannot be undone.',
            confirmText: 'Delete',
            type: 'is-danger',
            hasIcon: true,
            onConfirm: function () { return _this.sandTypeRemoved(product); },
            onCancel: function () { return _this.$apollo.queries.products.refetch(); }
        });
    };
    Admin.prototype.generateTempPassword = function () {
        var result = '';
        while (!result) {
            result = Math.random().toString(36).substring(2);
        }
        return result;
    };
    Admin.prototype.resetUserForm = function () {
        this.showEditUser = false;
        this.editUserEmailClass = '';
        this.editUserEmailWarning = '';
        this.editUserEmail = '';
        this.editUserCompany = '';
        this.editUserRole = '';
        this.editUserCurrent = {};
    };
    Admin.prototype.resetSiloForm = function () {
        this.showEditSilo = false;
        this.editSiloName = '';
        this.editSiloCompany = '';
        this.editSiloLocation = '';
        this.editSiloProduct = '';
        this.editSiloCapacity = null;
        this.editSiloCurrent = {};
        this.editSiloLoading = false;
        this.editSiloCurrentWeight = null;
        this.editSiloFeetDown = null;
        this.editSiloHeight = null;
    };
    Admin.prototype.resetExternalForm = function () {
        this.showEditExternal = false;
        this.editExternalLoading = false;
        this.editExternalCompany = '';
        this.editExternalLocation = '';
        this.editExternalProduct = '';
        this.editExternalCurrentWeight = null;
        this.editExternalCurrent = {};
    };
    Object.defineProperty(Admin.prototype, "verifyUserForm", {
        get: function () {
            if (this.editUserRole !== 'External User') {
                this.editUserCompany = '';
            }
            if (!this.editUserRole.length) {
                return false;
            }
            if (this.editUserRole === 'External User' && !this.editUserCompany.length) {
                return false;
            }
            if (!this.editUserEmail.length) {
                return false;
            }
            var emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (!emailRegex.test(this.editUserEmail)) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Admin.prototype, "verifySiloForm", {
        get: function () {
            if (!this.editSiloName || !this.editSiloName.length ||
                !this.editSiloCompany || !this.editSiloCompany.length ||
                !this.editSiloLocation || !this.editSiloLocation.length ||
                !this.editSiloProduct || !this.editSiloProduct.length) {
                return false;
            }
            else if (isNaN(this.editSiloHeight) ||
                isNaN(this.editSiloCapacity) ||
                isNaN(this.editSiloCurrentWeight) ||
                isNaN(this.editSiloFeetDown) ||
                strToFloat(this.editSiloCurrentWeight) > strToFloat(this.editSiloCapacity) ||
                strToFloat(this.editSiloFeetDown) < 0) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Admin.prototype, "verifyExternalForm", {
        get: function () {
            if (!this.editExternalCompany || !this.editExternalCompany.length ||
                !this.editExternalLocation || !this.editExternalLocation.length ||
                !this.editExternalProduct || !this.editExternalProduct.length) {
                return false;
            }
            else if (isNaN(this.editExternalCurrentWeight) || _.isNil(this.editExternalCurrentWeight)) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Admin.prototype.createNewUser = function () {
        this.resetUserForm();
        this.showEditUser = true;
    };
    Admin.prototype.cancelUpdateUser = function () {
        this.resetUserForm();
    };
    Admin.prototype.setEditUser = function () {
        this.showEditUser = true;
        this.editUserEmail = this.editUserCurrent.email;
        this.editUserRole = this.editUserCurrent.role;
        this.editUserCompany = this.editUserCurrent.company;
    };
    Admin.prototype.deleteUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.editUserLoading) {
                            return [2 /*return*/];
                        }
                        this.editUserLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$firebaseRefs.users.child(this.editUserCurrent['.key']).remove()];
                    case 2:
                        _a.sent();
                        this.resetUserForm();
                        this.$toast.open({
                            duration: 5000,
                            message: 'Successfully removed user',
                            position: 'is-top',
                            type: 'is-success'
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_9 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error deleting user. Please try again.',
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        this.editUserLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.updateUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.editUserLoading || !this.verifyUserForm) {
                            return [2 /*return*/];
                        }
                        this.editUserLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$firebaseRefs.users.child(this.editUserCurrent['.key']).set({
                                email: this.editUserEmail,
                                company: this.editUserCompany || 'Goodrich Mud',
                                role: this.editUserRole
                            })];
                    case 2:
                        _a.sent();
                        this.resetUserForm();
                        this.$toast.open({
                            duration: 5000,
                            message: 'Successfully updated user',
                            position: 'is-top',
                            type: 'is-success'
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_10 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error updating user. Please try again.',
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        this.editUserLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.createUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var randomPassword, newUser, e_11, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.editUserLoading || !this.verifyUserForm) {
                            return [2 /*return*/];
                        }
                        this.editUserLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        randomPassword = this.generateTempPassword();
                        return [4 /*yield*/, this.secondaryApp.auth().createUserWithEmailAndPassword(this.editUserEmail, randomPassword)];
                    case 2:
                        _a.sent();
                        newUser = __assign({}, this.secondaryApp.auth().currentUser);
                        return [4 /*yield*/, this.secondaryApp.auth().signOut()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, firebase.auth().sendPasswordResetEmail(this.editUserEmail)];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.$firebaseRefs.users.child(newUser.uid).set({
                                email: this.editUserEmail,
                                role: this.editUserRole,
                                company: this.editUserCompany || 'Goodrich Mud'
                            })];
                    case 5:
                        _a.sent();
                        this.resetUserForm();
                        this.$toast.open({
                            duration: 5000,
                            message: 'Successfully created user',
                            position: 'is-top',
                            type: 'is-success'
                        });
                        return [3 /*break*/, 7];
                    case 6:
                        e_11 = _a.sent();
                        message = 'There was an error saving user';
                        if (e_11.code === 'auth/email-already-in-use') {
                            message = 'An account for that email address already exists';
                        }
                        this.$toast.open({
                            duration: 5000,
                            message: message + ". Please try again.",
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 7];
                    case 7:
                        this.editUserLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.sendUserResetEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.editUserLoading || this.editUserResetEmailLoading) {
                            return [2 /*return*/];
                        }
                        this.editUserResetEmailLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, firebase.auth().sendPasswordResetEmail(this.editUserEmail)];
                    case 2:
                        _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'Successfully sent password reset email.',
                            position: 'is-top',
                            type: 'is-success'
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_12 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error sending password reset email. Please try again.',
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        this.editUserResetEmailLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.createNewExternal = function () {
        this.resetExternalForm();
        this.showEditExternal = true;
    };
    Admin.prototype.cancelUpdateExternal = function () {
        this.resetExternalForm();
    };
    Admin.prototype.setEditExternal = function () {
        this.showEditExternal = true;
        this.editExternalCompany = this.editExternalCurrent.company;
        this.editExternalLocation = this.editExternalCurrent.location;
        this.editExternalProduct = this.editExternalCurrent.product;
        this.editExternalCurrentWeight = this.editExternalCurrent.current_weight;
    };
    Admin.prototype.deleteExternal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.editExternalLoading) {
                            return [2 /*return*/];
                        }
                        this.editExternalLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_9 || (templateObject_9 = __makeTemplateObject(["mutation ($id: Int!) {\n          delete_externals(where: {id: {_eq: $id}}) {\n            affected_rows\n          }\n        }"], ["mutation ($id: Int!) {\n          delete_externals(where: {id: {_eq: $id}}) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    id: this.editExternalCurrent.id
                                }
                            })];
                    case 2:
                        _a.sent();
                        this.resetExternalForm();
                        this.$apollo.queries.externals.refetch();
                        return [3 /*break*/, 4];
                    case 3:
                        e_13 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error deleting external tracking. Please try again.',
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        this.editExternalLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.updateExternal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.editExternalLoading || !this.verifyExternalForm) {
                            return [2 /*return*/];
                        }
                        this.editExternalLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_10 || (templateObject_10 = __makeTemplateObject(["mutation ($id: Int!, $changes: externals_set_input) {\n          update_externals (\n            where: {id: {_eq: $id}},\n            _set: $changes\n          ) {\n            affected_rows\n          }\n        }"], ["mutation ($id: Int!, $changes: externals_set_input) {\n          update_externals (\n            where: {id: {_eq: $id}},\n            _set: $changes\n          ) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    id: this.editExternalCurrent.id,
                                    changes: {
                                        location: this.editExternalLocation,
                                        company: this.editExternalCompany,
                                        current_weight: strToFloat(this.editExternalCurrentWeight),
                                        product: this.editExternalProduct
                                    }
                                }
                            })];
                    case 2:
                        _a.sent();
                        this.resetExternalForm();
                        this.$apollo.queries.externals.refetch();
                        this.$toast.open({
                            duration: 5000,
                            message: 'Successfully updated external tracking.',
                            position: 'is-top',
                            type: 'is-success'
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_14 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error updating external tracking. Please try again.',
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        this.editExternalLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.checkExisingExternals = function () {
        var _this = this;
        return _.some(this.externals, function (external) {
            return external.company === _this.editExternalCompany &&
                external.location === _this.editExternalLocation &&
                external.product === _this.editExternalProduct;
        });
    };
    Admin.prototype.createExternal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.editExternalLoading || !this.verifyExternalForm) {
                            return [2 /*return*/];
                        }
                        if (this.checkExisingExternals()) {
                            this.$toast.open({
                                duration: 5000,
                                message: 'There is already external tracking with this information. Please try again.',
                                position: 'is-top',
                                type: 'is-danger'
                            });
                            return [2 /*return*/];
                        }
                        this.editExternalLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_11 || (templateObject_11 = __makeTemplateObject(["mutation ($externals: [externals_insert_input!]!) {\n          insert_externals(objects: $externals) {\n            affected_rows\n          }\n        }"], ["mutation ($externals: [externals_insert_input!]!) {\n          insert_externals(objects: $externals) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    externals: [{
                                            location: this.editExternalLocation,
                                            company: this.editExternalCompany,
                                            current_weight: strToFloat(this.editExternalCurrentWeight),
                                            product: this.editExternalProduct
                                        }]
                                }
                            })];
                    case 2:
                        _a.sent();
                        this.resetExternalForm();
                        this.$apollo.queries.externals.refetch();
                        this.$toast.open({
                            duration: 5000,
                            message: 'Successfully created external tracking.',
                            position: 'is-top',
                            type: 'is-success'
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_15 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error saving external tracking. Please try again.',
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        this.editExternalLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.createNewSilo = function () {
        this.resetSiloForm();
        this.showEditSilo = true;
    };
    Admin.prototype.cancelUpdateSilo = function () {
        this.resetSiloForm();
    };
    Admin.prototype.setEditSilo = function () {
        this.showEditSilo = true;
        this.editSiloName = this.editSiloCurrent.name;
        this.editSiloProduct = this.editSiloCurrent.product;
        this.editSiloLocation = this.editSiloCurrent.location;
        this.editSiloCompany = this.editSiloCurrent.company;
        this.editSiloCapacity = this.editSiloCurrent.capacity;
        this.editSiloCurrentWeight = this.editSiloCurrent.current_weight;
        this.editSiloHeight = this.editSiloCurrent.height;
        this.editSiloFeetDown = this.editSiloCurrent.feet_down;
    };
    Admin.prototype.deleteSilo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.editSiloLoading) {
                            return [2 /*return*/];
                        }
                        this.editSiloLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_12 || (templateObject_12 = __makeTemplateObject(["mutation ($silo: String!) {\n          delete_silos(where: {name: {_eq: $silo}}) {\n            affected_rows\n          }\n        }"], ["mutation ($silo: String!) {\n          delete_silos(where: {name: {_eq: $silo}}) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    silo: this.editSiloCurrent.name
                                }
                            })];
                    case 2:
                        _a.sent();
                        this.resetSiloForm();
                        return [4 /*yield*/, this.$apollo.queries.silos.refetch()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_16 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error deleting silo. Please try again.',
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 5];
                    case 5:
                        this.editSiloLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.updateSilo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.editSiloLoading || !this.verifySiloForm) {
                            return [2 /*return*/];
                        }
                        this.editSiloLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_13 || (templateObject_13 = __makeTemplateObject(["mutation ($name: String, $changes: silos_set_input) {\n          update_silos (\n            where: {name: {_eq: $name}},\n            _set: $changes\n          ) {\n            affected_rows\n          }\n        }"], ["mutation ($name: String, $changes: silos_set_input) {\n          update_silos (\n            where: {name: {_eq: $name}},\n            _set: $changes\n          ) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    name: this.editSiloCurrent.name,
                                    changes: {
                                        name: this.editSiloName,
                                        company: this.editSiloCompany,
                                        location: this.editSiloLocation,
                                        capacity: this.editSiloCapacity,
                                        product: this.editSiloProduct,
                                        height: this.editSiloHeight,
                                        current_weight: this.editSiloCurrentWeight,
                                        feet_down: this.editSiloFeetDown
                                    }
                                }
                            })];
                    case 2:
                        _a.sent();
                        this.resetSiloForm();
                        return [4 /*yield*/, this.$apollo.queries.silos.refetch()];
                    case 3:
                        _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'Successfully updated silo',
                            position: 'is-top',
                            type: 'is-success'
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        e_17 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error updating silo. Please try again.',
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 5];
                    case 5:
                        this.editSiloLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Admin.prototype.createSilo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.editSiloLoading || !this.verifySiloForm) {
                            return [2 /*return*/];
                        }
                        this.editSiloLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_14 || (templateObject_14 = __makeTemplateObject(["mutation ($silos: [silos_insert_input!]!) {\n          insert_silos(objects: $silos) {\n            affected_rows\n          }\n        }"], ["mutation ($silos: [silos_insert_input!]!) {\n          insert_silos(objects: $silos) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    silos: [{
                                            name: this.editSiloName,
                                            location: this.editSiloLocation,
                                            company: this.editSiloCompany,
                                            capacity: this.editSiloCapacity,
                                            product: this.editSiloProduct,
                                            height: this.editSiloHeight,
                                            current_weight: this.editSiloCurrentWeight,
                                            feet_down: this.editSiloFeetDown
                                        }]
                                }
                            })];
                    case 2:
                        _a.sent();
                        this.resetSiloForm();
                        return [4 /*yield*/, this.$apollo.queries.silos.refetch()];
                    case 3:
                        _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'Successfully created silo',
                            position: 'is-top',
                            type: 'is-success'
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        e_18 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error saving silo. Please try again.',
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 5];
                    case 5:
                        this.editSiloLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Admin = __decorate([
        Component({
            name: 'admin',
            apollo: {
                companies: {
                    query: function () { return COMPANIES; },
                    fetchPolicy: 'no-cache',
                    result: function (_a) {
                        var data = _a.data;
                        this.altCompanies = data.companies;
                    }
                },
                carriers: {
                    query: function () { return CARRIERS; },
                    fetchPolicy: 'no-cache',
                    result: function (_a) {
                        var data = _a.data;
                        this.altCarriers = data.carriers;
                    }
                },
                locations: {
                    query: function () { return LOCATIONS; },
                    fetchPolicy: 'no-cache',
                    result: function (_a) {
                        var data = _a.data;
                        this.altLocations = data.locations;
                    }
                },
                products: {
                    query: function () { return PRODUCTS; },
                    fetchPolicy: 'no-cache',
                    result: function (_a) {
                        var data = _a.data;
                        this.altProducts = data.products;
                    }
                },
                silos: {
                    query: function () { return SILOS; },
                    fetchPolicy: 'no-cache'
                },
                externals: {
                    query: function () { return EXTERNALS; },
                    fetchPolicy: 'no-cache'
                },
            },
            firebase: {
                roles: db.ref('roles').orderByChild('name'),
                users: db.ref('users').orderByChild('email')
            }
        })
    ], Admin);
    return Admin;
}(Vue));
export default Admin;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Admin.vue
// module id = 777
// module chunks = 1